export const translations = {
  ro: {
    // App
    appTitle: 'Calculator Financiar',
    appSubtitle: 'Planifică-ți viitorul financiar',
    heroTitle: 'Calculator Financiar',
    heroSubtitle: 'Planifică-ți viitorul financiar. Descoperă cum investițiile regulate și timpul pot transforma economiile tale în avere.',
    ctaButton: 'Calculează acum',
    calculator: 'Calculator',
    results: 'Rezultate',
    comparison: 'Comparație',
    darkMode: 'Mod întunecat',
    lightMode: 'Mod luminos',
    language: 'Limba',
    // Inputs
    initialDeposit: 'Depozit inițial',
    monthlyContribution: 'Contribuție lunară',
    annualInterestRate: 'Rata dobânzii anuale',
    investmentPeriod: 'Perioada (ani)',
    compoundingFrequency: 'Frecvența compunerii',
    contributionFrequency: 'Frecvența contribuțiilor',
    investmentType: 'Tip instrument',
    includeTaxes: 'Include impozit pe profit',
    adminFee: 'Comision administrativ',
    adminFeePercent: 'Comision administrativ (%/an)',
    // Pause
    contributionPause: 'Pauză contribuții',
    enablePause: 'Activează pauza',
    pauseStartYear: 'An început pauză',
    pauseEndYear: 'An final pauză',
    pauseDescription: 'În această perioadă nu se mai fac depuneri, dar dobânda continuă să se acumuleze',
    paused: 'Pauză',
    // Top-up & Withdrawals
    topUps: 'Depuneri suplimentare (Top-up)',
    addTopUp: 'Adaugă depunere',
    withdrawals: 'Retrageri parțiale',
    addWithdrawal: 'Adaugă retragere',
    year: 'An',
    amount: 'Sumă',
    remove: 'Șterge',
    // Frequency options
    monthly: 'Lunar',
    annually: 'Anual',
    quarterly: 'Trimestrial',
    semiannually: 'Semestrial',
    // Results
    finalValue: 'Valoare finală',
    totalContributions: 'Total contribuții',
    totalInterest: 'Dobândă câștigată',
    interestGross: 'Dobândă brută',
    interestNet: 'Dobândă netă',
    taxPaid: 'Impozit plătit',
    adminFeePaid: 'Comisioane plătite',
    effectiveReturn: 'Randament efectiv',
    totalTopUps: 'Total top-up',
    totalWithdrawals: 'Total retrageri',
    // Chart
    chartTitle: 'Evoluția investiției',
    contributions: 'Contribuții',
    interest: 'Dobândă',
    total: 'Total',
    // Table
    breakdownTitle: 'Evoluție anuală detaliată',
    yearColumn: 'An',
    startBalance: 'Sold inițial',
    yearContributions: 'Contribuții',
    yearInterest: 'Dobândă',
    endBalance: 'Sold final',
    totalColumn: 'Total acumulat',
    exportCSV: 'Exportă CSV',
    exportPDF: 'Exportă PDF',
    topUpCol: 'Top-up',
    withdrawalCol: 'Retragere',
    // Strategy Comparison
    strategyComparison: 'Comparație strategii',
    strategy1: 'Strategia curentă',
    strategy2: 'Strategie alternativă',
    alternativeContribution: 'Contribuție alternativă',
    compareWith: 'Compară cu',
    // Tax info
    taxDisclaimer: 'Simulare informativă. Consultați un specialist financiar pentru situații specifice.',
    simpleInterest: 'Dobândă simplă',
    compoundInterest: 'Dobândă compusă',
    // Tooltips
    tooltipInitialDeposit: 'Suma pe care o investești la început',
    tooltipMonthlyContribution: 'Suma pe care o adaugi în fiecare lună',
    tooltipInterestRate: 'Rata anuală de dobândă sau randament estimat',
    tooltipPeriod: 'Durata investiției în ani',
    tooltipCompounding: 'Cât de des se calculează și adaugă dobânda',
    tooltipInvestmentType: 'Alege tipul de instrument financiar',
    tooltipAdminFee: 'Comisionul anual reținut de administratorul fondului',
    tooltipPause: 'Perioada în care nu se mai fac contribuții, dar banii rămân investiți',
    // Child Future
    childAge: 'Vârsta copilului (ani)',
    parentAge: 'Vârsta părintelui (ani)',
    targetAge: 'Vârsta țintă (ani)',
    childPlanTitle: 'Plan Viitorul Copilului',
    childPlanDesc: 'Economisește pentru viitorul copilului tău',
    childAtMaturity: 'Copilul va avea',
    yearsAtEnd: 'ani la maturitate',
    // Credit
    creditTitle: 'Simulator Credit',
    loanAmount: 'Suma împrumutată',
    creditRate: 'Rata dobânzii (%/an)',
    creditTerm: 'Perioada de rambursare (luni)',
    monthlyFee: 'Comision lunar (%)',
    gracePeriod: 'Perioadă de grație (luni)',
    repaymentType: 'Tip rambursare',
    annuity: 'Anuități constante',
    equalPrincipal: 'Principal constant',
    extraPayment: 'Plată anticipată suplimentară',
    monthlyPayment: 'Rată lunară',
    totalPayment: 'Total de rambursat',
    totalInterestCredit: 'Total dobândă',
    totalFees: 'Total comisioane',
    creditBreakdown: 'Scadențar credit',
    monthCol: 'Lună',
    principalCol: 'Principal',
    interestCol: 'Dobândă',
    feeCol: 'Comision',
    paymentCol: 'Rată totală',
    balanceCol: 'Sold rămas',
    savingsVsCredit: 'Cont economii vs Credit',
    // Validation
    enterValue: 'Introdu o valoare',
    minValue: 'Valoare minimă',
    maxValue: 'Valoare maximă',
  },

  en: {
    appTitle: 'Financial Calculator',
    appSubtitle: 'Plan your financial future',
    heroTitle: 'Financial Calculator',
    heroSubtitle: 'Plan your financial future. Discover how regular investments and time can transform your savings into wealth.',
    ctaButton: 'Calculate now',
    calculator: 'Calculator',
    results: 'Results',
    comparison: 'Comparison',
    darkMode: 'Dark mode',
    lightMode: 'Light mode',
    language: 'Language',
    initialDeposit: 'Initial deposit',
    monthlyContribution: 'Monthly contribution',
    annualInterestRate: 'Annual interest rate',
    investmentPeriod: 'Period (years)',
    compoundingFrequency: 'Compounding frequency',
    contributionFrequency: 'Contribution frequency',
    investmentType: 'Instrument type',
    includeTaxes: 'Include profit tax',
    adminFee: 'Administrative fee',
    adminFeePercent: 'Administrative fee (%/year)',
    contributionPause: 'Contribution pause',
    enablePause: 'Enable pause',
    pauseStartYear: 'Pause start year',
    pauseEndYear: 'Pause end year',
    pauseDescription: 'During this period no contributions are made, but interest continues to accrue',
    paused: 'Paused',
    topUps: 'Additional deposits (Top-up)',
    addTopUp: 'Add deposit',
    withdrawals: 'Partial withdrawals',
    addWithdrawal: 'Add withdrawal',
    year: 'Year',
    amount: 'Amount',
    remove: 'Remove',
    monthly: 'Monthly',
    annually: 'Annually',
    quarterly: 'Quarterly',
    semiannually: 'Semi-annually',
    finalValue: 'Final value',
    totalContributions: 'Total contributions',
    totalInterest: 'Interest earned',
    interestGross: 'Gross interest',
    interestNet: 'Net interest',
    taxPaid: 'Tax paid',
    adminFeePaid: 'Fees paid',
    effectiveReturn: 'Effective return',
    totalTopUps: 'Total top-ups',
    totalWithdrawals: 'Total withdrawals',
    chartTitle: 'Investment evolution',
    contributions: 'Contributions',
    interest: 'Interest',
    total: 'Total',
    breakdownTitle: 'Detailed annual breakdown',
    yearColumn: 'Year',
    startBalance: 'Opening balance',
    yearContributions: 'Contributions',
    yearInterest: 'Interest',
    endBalance: 'Closing balance',
    totalColumn: 'Total accumulated',
    exportCSV: 'Export CSV',
    exportPDF: 'Export PDF',
    topUpCol: 'Top-up',
    withdrawalCol: 'Withdrawal',
    strategyComparison: 'Strategy comparison',
    strategy1: 'Current strategy',
    strategy2: 'Alternative strategy',
    alternativeContribution: 'Alternative contribution',
    compareWith: 'Compare with',
    taxDisclaimer: 'Informational simulation. Consult a financial specialist for specific situations.',
    simpleInterest: 'Simple interest',
    compoundInterest: 'Compound interest',
    tooltipInitialDeposit: 'The amount you invest at the start',
    tooltipMonthlyContribution: 'The amount you add each month',
    tooltipInterestRate: 'Annual interest rate or estimated return',
    tooltipPeriod: 'Investment duration in years',
    tooltipCompounding: 'How often interest is calculated and added',
    tooltipInvestmentType: 'Choose the type of financial instrument',
    tooltipAdminFee: 'Annual fee retained by the fund administrator',
    tooltipPause: 'Period during which no contributions are made but funds remain invested',
    childAge: 'Child age (years)',
    parentAge: 'Parent age (years)',
    targetAge: 'Target age (years)',
    childPlanTitle: "Child's Future Plan",
    childPlanDesc: "Save for your child's future",
    childAtMaturity: 'Child will be',
    yearsAtEnd: 'years old at maturity',
    creditTitle: 'Loan Simulator',
    loanAmount: 'Loan amount',
    creditRate: 'Interest rate (%/year)',
    creditTerm: 'Repayment period (months)',
    monthlyFee: 'Monthly fee (%)',
    gracePeriod: 'Grace period (months)',
    repaymentType: 'Repayment type',
    annuity: 'Constant annuities',
    equalPrincipal: 'Equal principal',
    extraPayment: 'Extra monthly payment',
    monthlyPayment: 'Monthly payment',
    totalPayment: 'Total repayment',
    totalInterestCredit: 'Total interest',
    totalFees: 'Total fees',
    creditBreakdown: 'Amortization schedule',
    monthCol: 'Month',
    principalCol: 'Principal',
    interestCol: 'Interest',
    feeCol: 'Fee',
    paymentCol: 'Total payment',
    balanceCol: 'Remaining balance',
    savingsVsCredit: 'Savings vs Credit',
    enterValue: 'Enter a value',
    minValue: 'Minimum value',
    maxValue: 'Maximum value',
  },
};
